import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubjectListRequest } from "../../../../redux/exam/examSlice";
import PersistentSidebarLayout from "../../../PersistentSidebarLayout/PersistentSidebarLayout";
import "./EnhanceYourPractice.css";

const SubjectList = () => {
  const dispatch = useDispatch();
  const { subjectList, loading, error } = useSelector(
    (state) => state.examSlice
  );

  const [activeSubject, setActiveSubject] = useState(null);

  useEffect(() => {
    dispatch(fetchSubjectListRequest({ paperType: 2 }));
  }, [dispatch]);

  useEffect(() => {
    if (subjectList.length > 0) {
      setActiveSubject(subjectList[0].sub_id);
    }
  }, [subjectList]);

  if (loading) {
    return (
      <PersistentSidebarLayout>
        <div>Loading...</div>
      </PersistentSidebarLayout>
    );
  }
  if (error) {
    return (
      <PersistentSidebarLayout>
        <div>Error: {error}</div>
      </PersistentSidebarLayout>
    );
  }

  return (
    <PersistentSidebarLayout>
      <div className="topic-wise-practice">
        <h1 className="topic-title">Topic Wise Practice</h1>

        <div className="subject-tabs">
          {subjectList.map((subject) => (
            <div
              key={subject.sub_id}
              className={`subject-tab ${
                activeSubject === subject.sub_id ? "active" : ""
              }`}
              onClick={() => setActiveSubject(subject.sub_id)}
            >
              <span className="subject-icon-small">
                <img src={subject.icon} alt={subject.sub_name} />
              </span>

              <span className="subject-name-text">{subject.sub_name}</span>

              <span
                className={`percentage-pill ${
                  activeSubject === subject.sub_id ? "active-pill" : ""
                }`}
              >
                {subject.percentage || "0"}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </PersistentSidebarLayout>
  );
};

export default SubjectList;
